import { PluginPostStatusInfo } from '@wordpress/editor';
import { __ } from '@wordpress/i18n';
import { TextControl } from '../shared/wp-form-controls';

import './map-embed-url.css';

export default function MapEmbedUrl( { url } ) {
	return (
		<PluginPostStatusInfo className="jeo-embed-url">
			<span>{ __( 'Embed URL', 'jeo' ) } </span>
			<TextControl readOnly value={ url } />
		</PluginPostStatusInfo>
	);
}
